(function () {
    "use strict";
    angular
        .module("common.services")
        .factory("pagesResource", ["$resource", pagesResource]);
    function pagesResource($resource) {
        return $resource("/api/pages/:id/:action/:actionParam", { id: "@id", action: "@action", actionParam: "@actionParam" }, {
            isFriendlyUrlAvailable: {
                method: "GET",
                params: { action: "isFriendlyUrlAvailable" }
            },
            isPageNameAvailable: {
                method: "GET",
                params: { action: "isPageNameAvailable" }
            },
            updatePage: {
                method: "PUT",
                params: { action: "updatePage" }
            },
            getPageDetail: {
                method: "GET",
                params: { action: "pageDetail" }
            },
            savePageDetail: {
                method: "POST",
                params: { action: "pageDetail" }
            },
            getCustomPage: {
                method: "GET",
                params: { action: "customPage" }
            }
        });
    }
    ;
}());
